/**
 * automatyczny obrót kart na mobile
 * 
 * @param conatinerClass {string} - klasa obracanych kart
 * @param openClass {string} - klasa otwartej karty
 * @param breakpoint {number} - breakpoint szerokości ekranu
 * @param offset {string} - offset dla wywołania obrotu
 */

function flipCardAuto(conatinerClass, openClass, breakpoint, offset) {
    if (window.innerWidth < breakpoint) {
        var continuousElements = document.getElementsByClassName(conatinerClass);

        for (var i = 0; i < continuousElements.length; i++) {
            new Waypoint({
                element: continuousElements[i],
                handler: function(direction) {
                    var openclasses = document.getElementsByClassName(openClass);
                    for (var c = 0; c < openclasses.length; c++) {
                        var element = openclasses[c];
                        element.classList.remove(openClass);
                    }
                    this.element.classList.add(openClass);
                }, 
                offset: offset,
            })
        }
    }
}

/**
 * manualny obrót kart na mobile
 * 
 * @param conatinerClass {string} - klasa obracanych kart
 * @param openClass {string} - klasa otwartej karty
 * @param dataAttrName {string} - atrybut data linku aktywującego
 */

function flipCardManual(conatinerClass, openClass, dataAttrName) {
    $('a[data-' + dataAttrName + ']').click(function(event) {
        var target = $(this).data(dataAttrName);
        $('.' + conatinerClass).each(function() {
            $(this).removeClass('in-*').removeClass(openClass);
        })

        $('#' + target).addClass(openClass);

        $('.' + conatinerClass).not('.' + openClass).hover(function() {
            $('#' + target).removeClass(openClass);
        });
    });
}


$('.input').on('change', function() {
    if ($(this).valid() == true) {
        $(this).parents('.input-container').addClass('valid');
    }
    else {
        $(this).parents('.input-container').removeClass('valid');
    }
});
$('.input').on('focus', function() {
    $(this).parents('.input-container').addClass('focus');
});
$('.input').on('blur', function() {
    $(this).parents('.input-container').removeClass('focus');

    if( $(this).val() ) {
        $(this).parents('.input-container').addClass('not-empty');
    }
    else {
        $(this).parents('.input-container').removeClass('not-empty');
    }
});